import { query_franchisee_wallet_list } from '@/api/jms-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/jms/jms-franchiseewallet-config';

import { reactive } from 'vue';
import { get_is_active, getDateTime, toFixed0 } from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'franchisee__name',
      label: 'franchisee__name',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写franchisee__name',
    },
    {
      type: 'input',
      name: 'franchisee__code',
      label: 'franchisee__code',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写franchisee__code',
    },
    {
      type: 'remotemodal',
      name: 'franchisee_id',
      label: '加盟商',
      disabled: false,
      placeholder: '请选择加盟商',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-franchisee',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    franchisee__name: null,
    franchisee__code: null,
    franchisee_id: null,
  }),
};
const search_options = {};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '加盟商钱包管理',
  addModalTitle: '新建加盟商钱包',
  updateTitle: '修改加盟商钱包',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '等级ID',
    width: 150,
    dataIndex: 'id',
    checked: false,
  },
  {
    title: '客户ID',
    width: 150,
    dataIndex: 'franchisee_id',
    checked: false,
  },
  {
    title: '名称',
    width: 150,
    dataIndex: 'franchisee__name',
    checked: true,
  },
  {
    title: '加盟商编号',
    width: 150,
    dataIndex: 'franchisee__code',
    checked: true,
  },
  {
    title: '充值余额',
    width: 150,
    dataIndex: 'real_money',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '返利余额',
    width: 150,
    dataIndex: 'void_money',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: true,

    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    checked: true,

    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    checked: true,

    cellComponent: 'boolean',
    name1: '可用',
    name2: '禁用',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active(text);
    },
  },

  {
    title: '操作',
    width: 200,
    dataIndex: 'action',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_franchisee_wallet_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
